import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { usePathPrefix } from '../../../../constants/hooks';

interface IProps {
  imagePath?: string;
  className?: string;
  color?: string;
  caption?: string;
}

const CaseStackCard: FC<IProps> = ({
  imagePath,
  color,
  children,
  className,
  caption,
}) => {
  const prefix = usePathPrefix();
  return (
    <div className={styles.card}>
      {caption && <div className={styles.card__сaption}>{caption}</div>}
      <div className={classNames(styles.card__content, className)}>
        <span
          className={styles.card__content__line}
          style={{ backgroundColor: color }}
        />
        {imagePath && <img src={`${prefix}${imagePath}`} alt="" />}
        <span>{children}</span>
      </div>
    </div>
  );
};

export { CaseStackCard };
